import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress-bar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "progress-bar__background" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "progress-bar__completed" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { computed } from 'vue'

export interface Props {
    completedPercentage?: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    completedPercentage: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { completedPercentage: number };

_useCssVars(_ctx => ({
  "221a4166": (_unref(completedPercentageFormatted))
}))



const completedPercentageFormatted = computed(() => {
  return props.completedPercentage + '%'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})